import { ClientBase } from '@master/model/ClientBase'

export default class InvestmentOption extends ClientBase {
    investmentOption = ''

    constructor (type: 'client_0' | 'client_1' = 'client_0') {
      super(type)
    }
}
